
import { defineComponent, PropType } from "vue";
import GameMatrix, { GameMatrixItem } from "@/data/GameMatrix";
import Color from "@/data/Color";

export default defineComponent({
  name: "GameMatrixDisplay",

  data() {
    return {
      itemMargin: 0.125,
    };
  },

  props: {
    matrix: {
      type: Object as PropType<GameMatrix>,
      required: true,
    },
    spacedItems: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 15,
    },
    hasDisabledStyle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    itemWidth() {
      let itemsPerRow = this.matrix.width;
      let margins = itemsPerRow * 2 * this.itemMargin;
      return parseFloat(((this.maxWidth - margins) / itemsPerRow).toFixed(4));
    },
    itemFontSize(): number {
      return parseFloat((this.itemWidth / 2).toFixed(4));
    },
    generalItemStyles() {
      return `width: ${this.itemWidth}rem; height: ${this.itemWidth}rem; margin: ${this.itemMargin}rem; font-size: ${this.itemFontSize}rem;`;
    },
    containerStyle() {
      return `width: ${this.maxWidth}rem;`;
    },
  },

  methods: {
    handleItemClick(item: GameMatrixItem) {
      if (item.isClickable) {
        this.$emit("item-click", item.id);
      }
    },
    styleByItem(item: GameMatrixItem) {
      let additionalStyles = "";
      if ((item.value + "").length > 2) {
        let fontSize = this.itemFontSize * 0.75;
        additionalStyles += `font-size: ${fontSize}rem; `;
      }
      if (item.type === "color" && (item.value as Color).value) {
        additionalStyles += `background: ${(item.value as Color).value}; `;
      }
      return `${this.generalItemStyles} ${additionalStyles}`;
    },
    classByItem(item: GameMatrixItem) {
      // TODO: prepare for color classes
      return {
        clickable: item.isClickable,
        disabled: !item.isClickable && this.hasDisabledStyle,
        "background--light": item.isActive,
      };
    },
  },
});
